import React from "react";
import { Pie } from "react-chartjs-2";
import { useSelector } from "react-redux";
import { Container, Row } from "react-bootstrap";
import { roundNumber } from "../../utils/Utils";
import { CryptoAssetColors } from "../../Const";


const DistributionPanel = (props) => {
  const theme =  useSelector((state) => state.settings.selected_theme) || 'light';
  const { coins,t ,heading} = props;
  var sortCoins = coins;
  if (sortCoins == null) {
    return <></>;
  }
  sortCoins.sort((coin1, coin2) => coin2.holdings - coin1.holdings);
  var topCoins = sortCoins.slice(0, 5);
  const otherCoins = sortCoins.slice(5);
  if (otherCoins.length > 0) {
    const otherHolding = otherCoins.reduce(
      (acc, item) => acc + item.holdings,
      0
    );
    topCoins.push({
      symbol: "Others",
      holdings: otherHolding,
    });
  }

  const labels = topCoins && topCoins.map((item) => item.symbol);
  const holdings =
    topCoins && topCoins.map((item) => roundNumber(item.holdings));
  return (
    <div className="distribution-panel futures">
      
      {/* <hr /> */}
      <div className="round-bg" style={{ marginTop: 30 }}>
        <h5 className="text-center mb-4">{heading}</h5>
        <Row>
          <Pie data={data(holdings, labels,theme)} options={options(holdings)} />
        </Row>
      </div>
    </div>
  );
};

export default DistributionPanel;

const data = (holdings, labels,theme) => ({
  labels,
  datasets: [
    {
      data: holdings,
      backgroundColor: CryptoAssetColors[theme],
    },
  ],
});

const options = (holdings) => {
  const fontColor = "#4c556a";
  return {
    maintainAspectRatio: false,
    legend: {
      position: "bottom",
      labels: {
        fontColor,
        boxWidth: 15,
        padding: 25,
      },
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          var label = holdings[tooltipItem.index] || 0;
          return label + "%";
        },
      },
    },
  };
};
